import ipAddress from 'ip-address'

// 참고 사이트 : http://ip-address.js.org/

export function isOrderedIp (ip1, ip2) {
  if (ip1 === undefined || ip1 === null || ip2 === undefined || ip2 === null) {
    return false
  }
  if (ip1.indexOf(':') >= 0) {
    const ip1Address = new ipAddress.Address6(ip1)
    const ip2Address = new ipAddress.Address6(ip2)
    if (ip1Address.isValid && ip2Address.isValid) {
      return _isOrderedIPv6(ip1Address, ip2Address)
    }
    return false
  } else if (ip1.indexOf('.') >= 0) {
    const ip1Address = new ipAddress.Address4(ip1)
    const ip2Address = new ipAddress.Address4(ip2)
    if (ip1Address.isValid && ip2Address.isValid) {
      return _isOrderedIPv4(ip1Address, ip2Address)
    }
    return false
  }
  return false
}

export function isOrderedIpEq (ip1, ip2) {
  if (ip1 === undefined || ip1 === null || ip2 === undefined || ip2 === null) {
    return false
  }
  if (ip1.indexOf(':') >= 0) {
    const ip1Address = new ipAddress.Address6(ip1)
    const ip2Address = new ipAddress.Address6(ip2)
    if (ip1Address.isValid && ip2Address.isValid) {
      return _isOrderedIPv6Eq(ip1Address, ip2Address)
    }
    return false
  } else if (ip1.indexOf('.') >= 0) {
    const ip1Address = new ipAddress.Address4(ip1)
    const ip2Address = new ipAddress.Address4(ip2)
    if (ip1Address.isValid && ip2Address.isValid) {
      return _isOrderedIPv4Eq(ip1Address, ip2Address)
    }
    return false
  }
  return false
}

function _isOrderedIPv4 (ip1Address, ip2Address) {
  if (ip1Address.toHex() < ip2Address.toHex()) return true
  return false
}

function _isOrderedIPv4Eq (ip1Address, ip2Address) {
  if (ip1Address.toHex() <= ip2Address.toHex()) return true
  return false
}

function _isOrderedIPv6 (ip1Address, ip2Address) {
  if (ip1Address.canonicalForm() < ip2Address.canonicalForm()) return true
  return false
}

function _isOrderedIPv6Eq (ip1Address, ip2Address) {
  if (ip1Address.canonicalForm() <= ip2Address.canonicalForm()) return true
  return false
}

/**
 * ipv4 형태 확인
 *
 * @param ip
 */
export function checkIpv4 (ip) {
  return new ipAddress.Address4(ip).isValid()
}

/**
 * ipv6 형태 확인
 *
 * @param ip
 */
export function checkIpv6 (ip) {
  return new ipAddress.Address6(ip).isValid()
}

export function checkZeroIp (ip) {
  if (checkIpv4(ip)) {
    if (ip === '0.0.0.0') {
      return true
    }
    return false
  } else if (checkIpv6(ip)) {
    const ipv6 = new ipAddress.Address6(ip)
    if (ipv6.parsedAddress.join(':') === '0:0:0:0:0:0:0:0') {
      return true
    }
    return false
  }
  return false
}

/**
 * IP 개수 조회
 *
 * @param fromIp
 * @param toIp
 * @returns {string}
 */
export function ip2ipMinus (fromIp, toIp) {
  const fromIps = fromIp.split('.')
  const toIps = toIp.split('.')
  const value = []
  let raise = false

  if (parseInt(toIps[3]) - parseInt(fromIps[3]) < 0) {
    raise = true
    value.push(parseInt(toIps[3]) + 256 - parseInt(fromIps[3]))
  } else {
    value.push(parseInt(toIps[3]) - parseInt(fromIps[3]))
  }

  let toint = raise ? parseInt(toIps[2]) - 1 : parseInt(toIps[2])
  raise = false

  if ((toint - parseInt(fromIps[2])) < 0) {
    raise = true
    value.push(toint + 256 - parseInt(fromIps[2]))
  } else {
    value.push(toint - parseInt(fromIps[2]))
  }

  toint = raise ? parseInt(toIps[1]) - 1 : parseInt(toIps[1])
  raise = false

  if ((toint - parseInt(fromIps[1])) < 0) {
    raise = true
    value.push(toint + 256 - parseInt(fromIps[1]))
  } else {
    value.push(toint - parseInt(fromIps[1]))
  }

  toint = raise ? parseInt(toIps[0]) - 1 : parseInt(toIps[0])

  if ((toint - parseInt(fromIps[0])) < 0) {
    value.push(toint + 256 - parseInt(fromIps[0]))
  } else {
    value.push(toint - parseInt(fromIps[0]))
  }

  return `${value[3]}.${value[2]}.${value[1]}.${value[0]}`
}
